import { Component, ElementRef, HostListener, Input, OnInit, ViewChild, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthService } from '../../../auth/services/auth.service';
import { ModalWindowsService } from '../../../modals/services/modal-windows.service';
import {
    closeSideMenu,
    openSideMenu,
} from '../../store/actions/commonSettings.action';
import { AppState } from '../../store/appState';
import { selectSideMenuIsOpen } from '../../store/selectors/commonSettings.selector';
import { HeaderNavigation } from '../header/header.component';
import { MatRipple } from '@angular/material/core';
import { AsyncPipe, NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
// import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { NotificationsService } from '../../services/notifications.service';
import { PlatformService } from '../../services/platform.service';
import { ProfileMainHubService } from '../../services/profile-main-hub.service';
import { DateFormatPipe } from '../../pipes/date-format.pipe';



declare const window: any;
@Component({
    imports: [
    MatRipple,
    AsyncPipe,
    MatIcon,
    NgClass,
    TranslatePipe,
    RouterLink,
],
    providers: [
        NotificationsService,
        PlatformService,
        ProfileMainHubService,
        DateFormatPipe,
    ],
    selector: 'app-mobile-side-menu',

    styleUrls: ['./mobile-side-menu.component.scss'],
    templateUrl: './mobile-side-menu.component.html',
})
export class MobileSideMenuComponent implements OnInit {
    private modalService = inject(ModalWindowsService);
    private store = inject<Store<AppState>>(Store);
    private authService = inject(AuthService);

    @Input()
    navigation: HeaderNavigation[];

    @ViewChild('navigationBlock', { read: ElementRef })
    navigationBlock: ElementRef;
    isVisible$ = this.store.select(selectSideMenuIsOpen);

    get isPlayer() {
        return this.authService.isPlayer;
    }

    @HostListener('document:mousedown', ['$event'])
    onGlobalClick(event: MouseEvent): void {
        if (!this.navigationBlock.nativeElement.contains(event.target)) {
            this.store.dispatch(closeSideMenu());
        }
    }

    ngOnInit(): void {}

    openMenu() {
        this.store.dispatch(openSideMenu());
    }

    hideMenu() {
        this.store.dispatch(closeSideMenu());
    }

    openInNewTab(navItem: HeaderNavigation) {
        this.hideMenu();
        window.zE('messenger', 'open');

    }
}
